import { ElementRef } from '@angular/core';
import { Directive, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, tap } from 'rxjs/operators';
import { CapabilitiesService } from 'src/app/shared/services/capabilities/capabilities.service';
import { CapabilityParams } from '../capabilities-params.model';

@UntilDestroy()
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[showIfHasCapability]',
    standalone: false
})
export class ShowIfHasCapabilityDirective implements OnInit {

  @Input('showIfHasCapability') capabilities: CapabilityParams[];

  constructor(
    private el: ElementRef,
    private capabilitiesService: CapabilitiesService
  ) { }

  ngOnInit(): void {
    this.el.nativeElement.style.display = "none";
    this.capabilitiesService.userHasAnyCapability(this.capabilities).pipe(
      filter(hasCapability => hasCapability !== null || hasCapability !== undefined),
      tap(hasCapability => {
        if (hasCapability) {
          this.el.nativeElement.style.display = "inline-block";
        }
      }),
      untilDestroyed(this)
    ).subscribe();
  }
}
